import React from "react";
import ReactDOM from "react-dom/client";
import AppointmentApp from "./appointment/App";
import AppointmentCreatedApp from "./appointment/created/App";
import { BaseApp } from "./BaseApp";
import BusinessConfiguratorApp from "./business-configurator/App";
import CheckoutApp from "./checkout/App";
import ConfiguratorApp from "./configurator/App";
import PaymentApp from "./payment/App";
import SamplesApp from "./samples/App";
import StatusAppointmentApp from "./status/appointment/App";
import StatusPaymentApp from "./status/payment/App";

export class GersFullApp extends BaseApp {
  public render = () => {
    const root = ReactDOM.createRoot(
      document.querySelector(this.htmlSelector) as HTMLElement,
    );

    root.render(
      <React.StrictMode>
        <div className="gg">
          <CheckoutApp configuration={this.configuration} />
          <BusinessConfiguratorApp configuration={this.configuration} />
          <ConfiguratorApp configuration={this.configuration} />
          <PaymentApp configuration={this.configuration} />
          <StatusAppointmentApp configuration={this.configuration} />
          <StatusPaymentApp configuration={this.configuration} />
          <AppointmentApp configuration={this.configuration} />
          <AppointmentCreatedApp configuration={this.configuration} />
          <SamplesApp configuration={this.configuration} />
        </div>
      </React.StrictMode>,
    );
  };
}
